import { useState } from "react";
import { Container } from "react-bootstrap";
import FreelancerserplaceNavbar from "../../signup/SubComponents/FreelancerserplaceNavbar";
import RegisterModal from "../../signup/RegisterModal";
import Footer from "../../signup/SubComponents/Footer";
import { MockCrmDashboard } from "./Components/MockScreens";

const CrmLandingpage = () => {
  const [showRegister, setShowRegister] = useState(false);

  const features = [
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
        </svg>
      ),
      title: "Contact Management",
      text: "Keep all your clients, leads and prospects in one place. Store contact details, notes and communication history.",
    },
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
      ),
      title: "Follow-up Reminders",
      text: "Never lose a lead again. Set follow-up dates and get reminded when it's time to reach out.",
    },
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      ),
      title: "Companies & Persons",
      text: "Link individual contacts to their companies. Build a complete picture of every client relationship.",
    },
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
        </svg>
      ),
      title: "Linked to Everything",
      text: "Contacts connect directly to projects, invoices and time tracking. No duplicate data entry.",
    },
  ];

  return (
    <>
      <RegisterModal show={showRegister} setShow={setShowRegister} showLoginForm={false} />
      <FreelancerserplaceNavbar />

      {/* Hero */}
      <div className="lp-hero-bg">
        <Container>
          <div style={{
            display: "grid", gridTemplateColumns: "1fr 1fr",
            gap: "3rem", alignItems: "center",
            paddingTop: "5rem", paddingBottom: "5rem",
            position: "relative",
          }}>
            <div className="yellowdotWelcome" />
            <div className="greendotWelcome" />
            <div>
              <div className="lp-badge">CRM</div>
              <h1 className="lp-hero-title">
                Know your clients, <span style={{ color: "#007BFF" }}>grow your business</span>
              </h1>
              <p className="lp-hero-subtitle">
                A simple CRM built for freelancers. Keep track of every contact, conversation and follow-up — without the bloat of enterprise software.
              </p>
              <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", alignItems: "center" }}>
                <button className="lp-cta-btn btn btn-primary" onClick={() => setShowRegister(true)}>
                  Try now for free
                </button>
                <a href="https://demo.freelancersplace.net" target="_blank" rel="noreferrer" className="lp-demo-link">
                  View demo →
                </a>
              </div>
              <div className="lp-trust-badges">
                <span>✓ 30-day free trial</span>
                <span>✓ No credit card required</span>
              </div>
            </div>

            <div>
              <div className="reddotWelcome" />
              <MockCrmDashboard />
            </div>
          </div>
        </Container>
      </div>

      {/* Feature grid */}
      <div className="lp-section-alt">
        <Container>
          <div style={{ paddingTop: "4rem", paddingBottom: "4rem" }}>
            <div style={{ textAlign: "center", marginBottom: "3rem" }}>
              <span className="blueSubheaderTop">Everything you need</span>
              <h2 className="landingpageHeader" style={{ fontWeight: 400, marginTop: "0.5rem" }}>
                All your contacts in one place
              </h2>
            </div>
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
              gap: "1.25rem",
            }}>
              {features.map(({ icon, title, text }) => (
                <div key={title} style={{
                  background: "#fff",
                  border: "1px solid #e8edf5",
                  borderRadius: "1rem",
                  padding: "1.5rem",
                  transition: "box-shadow 0.15s, transform 0.15s",
                }}
                  onMouseOver={e => { e.currentTarget.style.boxShadow = "0 8px 32px rgba(0,0,0,0.1)"; e.currentTarget.style.transform = "translateY(-2px)"; }}
                  onMouseOut={e => { e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.transform = "none"; }}
                >
                  <div style={{
                    width: "44px", height: "44px", borderRadius: "10px",
                    background: "#e8f1ff", display: "flex", alignItems: "center",
                    justifyContent: "center", color: "#007BFF", marginBottom: "1rem",
                  }}>
                    {icon}
                  </div>
                  <h4 style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: "1rem", marginBottom: "0.5rem" }}>
                    {title}
                  </h4>
                  <p className="landingpageDescriptions" style={{ marginBottom: 0 }}>{text}</p>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </div>

      {/* CTA */}
      <Container>
        <div style={{
          textAlign: "center", padding: "5rem 1rem",
          borderBottom: "1px solid #f0f0f0",
        }}>
          <h2 className="landingpageHeader" style={{ fontWeight: 400 }}>
            Ready to build better client relationships?
          </h2>
          <p className="landingpageDescriptions" style={{ maxWidth: "480px", margin: "0 auto 2rem" }}>
            Join freelancers who use FreelancersPlace to stay on top of every contact, project and deal.
          </p>
          <button className="lp-cta-btn btn btn-primary" onClick={() => setShowRegister(true)}>
            Start free trial
          </button>
        </div>
      </Container>

      <Footer />
    </>
  );
};

export default CrmLandingpage;
